import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sme-detail',
  templateUrl: './sme-detail.component.html',
  styleUrls: ['./sme-detail.component.scss']
})
export class SmeDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
